import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import PortalSearchTable from "../../common/table/PortalSearchTable";
import React from "react";
import { useFormContext } from "react-hook-form";
import { openModal } from "../../../../store/redux/slice/ComponentsControl/rolesControl";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { SecurityRole, SecurityGuard, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.person.name",
  },
  {
    id: "description",
    label: "l.table.head.description",
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const RolesListTable = ({ records, total, onPageOrOrderChange, blockTable, group }) => {
  const { getValues } = useFormContext();
  const dispatch = useAppDispatch();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <>
      <PortalSearchTable
        group={group}
        headCells={headCells}
        total={total}
        blockTable={blockTable}
        onPageOrOrderChange={onPageOrOrderChange}
      >
        <TableBody>
          {records.map((row, index) => {
            return (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <OptionTableCell>
                  <TableButton type={"view"} onClick={() => handleOpenModal(row.id, "view")} />
                  <SecurityGuard checkForRoles={[SecurityRole.AcRolesEdit]}>
                    <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, "edit")} />
                  </SecurityGuard>
                </OptionTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </PortalSearchTable>
    </>
  );
};

export default RolesListTable;
